import styled from "styled-components";
import Outline16MoveLayerDown from '@mds/mds-icons/icons/svg/outline-16-move-layer-down.svg';
import Outline32CRemove from '@mds/mds-icons/icons/svg/outline-32-c-remove.svg';

const Wrapper = styled.section`
  display: flex;
  min-height: calc(100vh - 90px);
  .preview-wrapper {
    width: 100%;
    height: 100%;
    z-index: 11;
    background: rgba(0, 0, 0, 0.8);
    top: 0;
    left: 0;
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;

    .preview {
      position: relative;
      display: flex;
      flex-direction: column;
      width: 100%;
      max-width: 80vw;
      height: 90vh;
      background: #fff;
      padding: 30px 50px;
      box-sizing: border-box;

      .loadingWrapper {
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        svg {
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }
      }

      object {
        width: 100%;
        height: 100%;
      }

      .close {
        position: absolute;
        background: transparent url('${Outline32CRemove}') no-repeat center;
        background-size: 24px;
        border-radius: 50%;
        opacity: 0.7;
        border: none;
        right: 10px;
        top: 10px;
        width: 32px;
        height: 32px;

        &:hover {
          background: #f2f2f2 url('${Outline32CRemove}') no-repeat center;
          background-size: 24px;
          opacity: 1;
        }
      }

      h1 {
        font-size: 24px;
        font-weight: normal;
      }

      p {
        font-size: 14px;
        margin: 10px 0 24px;
        color: #6c6c6c;
      }

      .doc {
        flex: 1;
        padding: 0 50px;
        border: solid thin #ccc;
      }

      .buttons {
        margin-top: 24px;
        display: flex;
        justify-content: end;
        gap: 10px;
      }
    }
  }

  .left {
    border-right: solid thin #ccc;
    width: 256px;

    h2 {
      padding: 20px 20px 20px 30px;
      background: rgb(250, 250, 250);
    }

    a {
      width: 100%;
      padding: 10px 10px 10px 15px;
      border-left: 5px solid transparent;
      display: block;
      cursor: pointer;
      margin-right: 0 !important;

      &.active {
        color: rgb(51, 51, 51);
        border-left: 5px solid rgb(34, 81, 204);
        background: #e6e6e6;
      }

      &.active + button {
        color: rgb(51, 51, 51);
        background: #e6e6e6 !important;
      }
    }

    button {
      height: 45px !important;
    }
  }

  .right {
    flex: 1;
    background: #fafafa;
    overflow: hidden;
    scroll-behavior: smooth;

    .loadingWrapper {
      height: calc(100vh - 190px);
      max-width: 960px;
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        animation: spin 1s linear infinite;
      }

      @keyframes spin {
        to {
          transform: rotate(360deg);
        }
      }
    }
  }

  .content {
    margin: 30px;
    min-height: calc(100vh - 210px);
    box-sizing: border-box;
    font-family: McKinsey Sans;

    > p {
      margin: 20px 0;
    }

    h1 {
      font-size: 24px;
      margin-bottom: 20px;
      font-weight: bold;
    }

    .faq-intro {
      max-width: 80%;
      line-height: 24px;
      font-size: 16px;
      font-weight: normal;
      a {
        color: #2251ff;
        text-decoration: none;
        &:hover {
            text-decoration: underline;
        }
    }
    }

    .accordian {
      max-width: 80%;

      .faq-question {
        font-family: McKinsey Sans;
        font-weight: 700;
        font-size: 1.0625rem;
        line-height: 1.45;
        margin: 0;
      }

      .faq-answer {
        font-size: 1rem;
        font-weight: normal;
        line-height: 1.5;

        strong,
        b {
          font-family: McKinsey Sans;
          font-weight: 700 !important;
        }

        ul {
          margin: 0.35em 0 0.5em;
          padding-left: 1.35em;
          list-style-type: disc;
          list-style-position: outside;
        }

        ul ul {
          list-style-type: circle;
          margin-top: 0.35em;
          margin-bottom: 0.35em;
        }

        li {
          margin: 0.35em 0;
        }

        p {
          line-height: 1.5;
        }
      }

      .highlight {
        background: #b2e5fb;
      }
    }

    .data-policy {
      max-width: 80%;

      p,
      li {
        font-size: 14px;
        line-height: 20px;
      }

      ol {
        margin: 20px;

        li {
          margin: 10px 0;
        }
      }
    }

    .methodology {
      .box {
        border: solid thin #ccc;
      }

      .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #f2f2f2;
        padding: 10px 20px;

        h2 {
          margin-bottom: 10px;
        }

        .rightContent .flex > div:first-of-type {
          margin-left: 10px;
          margin-right: 5px;
        }
      }

      .document-player {
        border-right: solid thin #ccc;
        border-top: solid thin #ccc;
        padding: 30px;
        width: auto;
        display: inline-block;
      }

      .rightContent {
        text-align: right;
      }

      .download {
        padding-left: 16px;
        display: inline-block;
        margin-top: 10px;

        &:after {
          content: "kjk";
          display: inline-block;
          width: 16px !important;
          height: 16px !important;
          border: solid thin lime;
          background: #2251ff;
          -webkit-mask: url('${Outline16MoveLayerDown}');
          -webkit-mask-size: cover;
        }
      }

      .loadingWrapper {
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        svg {
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }
      }

      input {
        color: #2251ff !important;
        font-size: 14px;
        font-weight: bold;
        background: none;
        width: auto;
        border: none;
        padding: 10px 0;
      }
    }

    .flex {
      margin: 30px 0;
      max-width: 960px;
      flex-wrap: wrap;
      gap: 30px;

      > div {
        width: 300px;
        height: 380px;
        transition: 0.4s;

        &:hover {
          transform: translate(0, -4px);
          box-shadow: 0 16px 32px -1px #051c2c33, 0 0 1px #051c2c26;
        }

        .mds-card-image {
          transition: 0.4s;

          img {
            aspect-ratio: 16 / 9;
            object-fit: cover;
            vertical-align: middle;
            min-height: 168px;
          }
        }

        .mds-card-title {
          // Optional styling block
        }

        .mds-card-body {
          max-height: 300px;

          .mds-card-content {
            div:last-of-type {
              height: 52px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
          }

          .mds-card-social {
            margin-top: 1rem;
          }
        }
      }
    }

    button {
      text-align: left;
      font-weight: normal;
    }

    > p {
      color: #757575;
    }
  }
`;

export const ContentPlaceholder = styled.div`
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0;
  height: calc(100vh - 190px);
`;

export default Wrapper;